import React from "react";
import withStyles from "react-jss";
import FooterMenuContainer from "Containers/FooterMenuContainer";
import PhoneContainerNew from "Containers/PhoneContainerNew";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import NoIndex from "ComponentsUI/NoIndex";
import ProviderConnectWithPhoneHOC from "HOC/ProviderConnectWithPhoneHOC";
import { CLICK_VK } from "Constants/metriks/Yandex";
import { sendMetriks } from "Services/sendMetriks";

const styles = (theme) => {
	return {
		root: {
			backgroundColor: theme.palette.colors.white,
			position: "relative",
			zIndex: 0,
		},
		wrapperMain: {
			padding: "34px 0 29px",
			display: "flex",
			alignItems: "flex-start",
		},
		mainInfo: {
			marginLeft: "auto",
			width: "180px",
			flexShrink: 0,
		},
		mainInfoPhoneWrapper: {
			width: "100%",
			marginBottom: "8px",
			position: "relative",
			"& .icon24": {
				position: "absolute",
				left: "-44px",
				top: "6px",
				color: theme.palette.colors.purplishBlue,
				fontSize: "24px",
			},
		},
		mainInfoPhone: {
			fontFamily: theme.fonts.bold,
			fontSize: "18px",
			lineHeight: "2",
			color: theme.palette.colors.darkSlateBlue,
		},
		mainInfoPhoneText: {
			fontFamily: theme.fonts.light,
			fontSize: "14px",
			lineHeight: "1.14",
			color: theme.palette.colors.oneMoreGrey,
		},
		wrapperSecondary: {
			display: "flex",
			height: "80px",
			alignItems: "center",
			justifyContent: "space-between",
			borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
		},
		secondaryWarning: {
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			lineHeight: "1.38",
			color: theme.palette.colors.oneMoreGrey,
		},
		secondaryNetworksWrapper: {
			display: "flex",
			alignItems: "center",
		},
		secondaryNetworksText: {
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			lineHeight: "1.38",
			color: theme.palette.colors.oneMoreGrey,
			marginRight: "20px",
		},
		secondaryNetworksList: {
			display: "flex",
			alignItems: "center",
		},
		secondaryNetworksListItem: {
			marginRight: "20px",
			display: "block",
			minHeight: "24px",
			"& span": {
				fontSize: "24px",
				color: theme.palette.colors.oneMoreGrey,
			},
			"& svg": {
				width: "24px",
				height: "24px",
			},
			"&:last-child": {
				marginRight: "3px",
			},
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			mainInfo: {
				marginLeft: "auto",
				width: "220px",
				paddingLeft: "30px",
			},
		},
		[`@media (max-width: ${theme.media.md})`]: {
			wrapperMain: {
				padding: "37px 60px 40px",
				flexWrap: "wrap",
			},
			mainInfo: {
				marginLeft: 0,
				width: "100%",
				flexShrink: 0,
				display: "flex",
				alignItems: "flex-start",
				marginTop: "31px",
			},
			mainInfoPhoneWrapper: {
				width: "auto",
				margin: "0 auto",
				"& .icon24": {
					top: "4px",
				},
			},
			mainInfoPhone: {
				fontSize: "16px",
				lineHeight: "1.88",
			},
			mainInfoPhoneText: {
				fontSize: "12px",
				lineHeight: "1.33",
				width: "160px",
			},
			wrapperSecondary: {
				height: "auto",
				alignItems: "flex-start",
				justifyContent: "center",
				padding: "25px 0 35px",
				margin: "0 60px",
				flexWrap: "wrap",
			},
			secondaryWarning: {
				fontSize: "14px",
				lineHeight: "1.43",
				width: "100%",
				textAlign: "center",
				marginBottom: "25px",
			},
			secondaryNetworksText: {
				fontSize: "14px",
				lineHeight: "1.43",
				marginRight: "25px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			wrapperMain: {
				padding: "32px 8.33% 32px",
				flexWrap: "wrap",
			},
			mainInfo: {
				marginLeft: "auto",
				width: "100%",
				flexShrink: "0",
				display: "flex",
				alignItems: "flex-start",
				marginTop: "24px",
				flexWrap: "wrap",
				justifyContent: "space-between",
			},
			mainInfoPhoneWrapper: {
				width: "auto",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexWrap: "wrap",
				margin: "0 auto",
				paddingLeft: "0",
				"& .icon24": {
					top: "0px",
					position: "relative",
					marginRight: "10px",
					fontSize: "20px",
					left: 0,
				},
			},
			mainInfoPhone: {
				fontSize: "14px",
				lineHeight: "2.14",
			},
			mainInfoPhoneText: {
				fontFamily: theme.fonts.light,
				fontSize: "12px",
				lineHeight: "1.2",
				color: theme.palette.colors.oneMoreGrey,
				width: "100%",
				textAlign: "center",
			},
			wrapperSecondary: {
				display: "flex",
				height: "auto",
				alignItems: "flex-start",
				justifyContent: "center",
				borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
				padding: "32px 0",
				margin: "0 8.33%",
				flexWrap: "wrap",
			},
			secondaryWarning: {
				fontSize: "12px",
				lineHeight: "1.67",
				width: "100%",
				textAlign: "center",
				marginBottom: "14px",
			},
			secondaryNetworksText: {
				fontSize: "12px",
				lineHeight: "1.67",
				marginRight: "20px",
			},
			secondaryNetworksListItem: {
				marginRight: "12px",
				minHeight: "20px",
				"& span": {
					fontSize: "20px",
				},
				"& svg": {
					width: "20px",
					height: "20px",
				},
				"&:last-child": {
					marginRight: 0,
				},
			},
		},
		[`@media (max-width: ${theme.media.footerXs})`]: {
			mainInfo: {
				flexWrap: "wrap",
				justifyContent: "center",
			},
			mainInfoPhoneWrapper: {
				margin: "0 auto",
			},
		},
	};
};

class Footer extends React.Component {
	constructor(props) {
		super(props);
	}

	handlePhoneClickDesktop() {
		sendMetriks("CLICK_FOOTER_PHONE_BUTTON_REAL");
	}

	handlePhoneClickMobile() {
		sendMetriks("CLICK_COMPASSION_PHONE_BUTTON_REAL");
	}

	render() {
		let classes = this.props.classes;
		const text = this.props.text;
		let socialUrls = this.props.socialUrls;
		let isDesktop = this.props.isDesktop;

		socialUrls.facebook = "";
		socialUrls.instagram = "";

		return (
			<div className={classes.root}>
				<Container>
					<Row>
						<Col xs="12">
							<div className={classes.wrapperMain} datatest={this.props.datatest}>
								<FooterMenuContainer />
								{(this.props.showPhone || this.props.phone404) && (
									<div className={classes.mainInfo}>
										{this.props.region && (
											<div className={classes.mainInfoPhoneWrapper}>
												<span className="icon24 icon-call" />
												<span className={classes.mainInfoPhone}>
													{isDesktop ? (
														<ProviderConnectWithPhoneHOC footer={true}>
															<PhoneContainerNew
																withoutIcon={true}
																roistatClass={"roistat-phone"}
																phone404={this.props.phone404}
																onClickPhone={this.handlePhoneClickDesktop}
															/>
														</ProviderConnectWithPhoneHOC>
													) : (
														<PhoneContainerNew
															withoutIcon={true}
															roistatClass={"roistat-phone"}
															phone404={this.props.phone404}
															onClickPhone={this.handlePhoneClickMobile}
														/>
													)}
													<div className={classes.mainInfoPhoneText}>
														{text.CONSULTATION_FREE_TIME}
													</div>
												</span>
											</div>
										)}
									</div>
								)}
							</div>
							<div className={classes.wrapperSecondary}>
								<div className={classes.secondaryWarning}>
									<NoIndex>
										{`© 2008-${new Date().getFullYear()} «${
											this.props.siteName
										}» ${text.COPYRIGHT_SPBONLINE}`}
									</NoIndex>
								</div>
								<div className={classes.secondaryNetworksWrapper}>
									<div className={classes.secondaryNetworksText}>{text.WE_IN_SOCIAL_NETWORKS}</div>
									{!!socialUrls && (
										<div className={classes.secondaryNetworksList}>
											{/*{!!socialUrls.facebook && (*/}
											{/*    <a*/}
											{/*        className={*/}
											{/*            classes.secondaryNetworksListItem*/}
											{/*        }*/}
											{/*        aria-label={*/}
											{/*            socialUrls.facebook*/}
											{/*        }*/}
											{/*        rel="noopener"*/}
											{/*        target="_blank"*/}
											{/*        datatest="main_facebook_button"*/}
											{/*        href={socialUrls.facebook}*/}
											{/*        onClick={() =>*/}
											{/*            this.props.onClickSocialHandler(*/}
											{/*                CLICK_FACEBOOK*/}
											{/*            )*/}
											{/*        }*/}
											{/*    >*/}
											{/*        <span className="icon24 icon-facebook" />*/}
											{/*    </a>*/}
											{/*)}*/}
											{/*{!!socialUrls.instagram && (*/}
											{/*    <a*/}
											{/*        className={*/}
											{/*            classes.secondaryNetworksListItem*/}
											{/*        }*/}
											{/*        aria-label={*/}
											{/*            socialUrls.instagram*/}
											{/*        }*/}
											{/*        target="_blank"*/}
											{/*        rel="noopener"*/}
											{/*        datatest="main_instagram_button"*/}
											{/*        href={socialUrls.instagram}*/}
											{/*        onClick={() =>*/}
											{/*            this.props.onClickSocialHandler(*/}
											{/*                CLICK_INSTAGRAM*/}
											{/*            )*/}
											{/*        }*/}
											{/*    >*/}
											{/*        <span className="icon32 icon-instagram" />*/}
											{/*    </a>*/}
											{/*)}*/}
											{/* {!!socialUrls.twitter && (
                                                <a
                                                    className={
                                                        classes.secondaryNetworksListItem
                                                    }
                                                    aria-label={
                                                        socialUrls.twitter
                                                    }
                                                    target="_blank"
                                                    rel="noopener"
                                                    datatest="main_twitter_button"
                                                    href={socialUrls.twitter}
                                                    onClick={() =>
                                                        this.props.onClickSocialHandler(
                                                            CLICK_TWITTER
                                                        )
                                                    }
                                                >
                                                    <span className="icon60 icon-twitter" />
                                                </a>
                                            )} */}
											{!!socialUrls.vkontakte && (
												<a
													className={classes.secondaryNetworksListItem}
													target="_blank"
													aria-label={socialUrls.vkontakte}
													rel="noopener"
													datatest="main_vk_button"
													href={socialUrls.vkontakte}
													onClick={() => this.props.onClickSocialHandler(CLICK_VK)}
												>
													<span className="icon32 icon-vk" />
												</a>
											)}
											{/*{!!socialUrls.vkontakte && (*/}
											{/*    <a*/}
											{/*        className={*/}
											{/*            classes.secondaryNetworksListItem*/}
											{/*        }*/}
											{/*        target="_blank"*/}
											{/*        aria-label={*/}
											{/*            socialUrls.vkontakte*/}
											{/*        }*/}
											{/*        rel="noopener"*/}
											{/*        datatest="main_vk_button"*/}
											{/*        href={*/}
											{/*            "https://vk.com/team101internet"*/}
											{/*        }*/}
											{/*        onClick={() =>*/}
											{/*            this.props.onClickSocialHandler(*/}
											{/*                CLICK_VK*/}
											{/*            )*/}
											{/*        }*/}
											{/*    >*/}
											{/*        <span className="icon32 icon-vk" />*/}
											{/*    </a>*/}
											{/*)}*/}
											{!!socialUrls.odnoklassniki && (
												<a
													className={classes.secondaryNetworksListItem}
													target="_blank"
													aria-label={socialUrls.odnoklassniki}
													rel="noopener"
													datatest="main_vk_button"
													href={socialUrls.odnoklassniki}
													onClick={() => this.props.onClickSocialHandler(CLICK_VK)}
												>
													<svg
														viewBox="0 0 10 16"
														xmlns="http://www.w3.org/2000/svg"
														height="102.5"
													>
														<g fill="none" stroke="#8e87a3" strokeWidth="2.4" strokeLinecap="round">
															<circle r="2.9" cx="4.9" cy="4.3" />
															<polyline points="1.8 14.6, 4.9 11.5, 7.9 14.6" />
															<path d="M1.6,9.6 a6.6,6.6 0 0,0 6.6,0" />
														</g>
													</svg>
												</a>
											)}
											<a
												className={classes.secondaryNetworksListItem}
												target="_blank"
												aria-label={"yan-dzen"}
												rel="noopener"
												href={"https://zen.yandex.ru/id/5ae1dd2455876b8b5f233540"}
											>
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
													<path
														fill="#2C3036"
														d="M16.7 16.7c-2.2 2.27-2.36 5.1-2.55 11.3 5.78 0 9.77-.02 11.83-2.02 2-2.06 2.02-6.24 2.02-11.83-6.2.2-9.03.35-11.3 2.55M0 14.15c0 5.59.02 9.77 2.02 11.83 2.06 2 6.05 2.02 11.83 2.02-.2-6.2-.35-9.03-2.55-11.3-2.27-2.2-5.1-2.36-11.3-2.55M13.85 0C8.08 0 4.08.02 2.02 2.02.02 4.08 0 8.26 0 13.85c6.2-.2 9.03-.35 11.3-2.55 2.2-2.27 2.36-5.1 2.55-11.3m2.85 11.3C14.5 9.03 14.34 6.2 14.15 0c5.78 0 9.77.02 11.83 2.02 2 2.06 2.02 6.24 2.02 11.83-6.2-.2-9.03-.35-11.3-2.55"
													/>
													<path
														fill="#fff"
														d="M28 14.15v-.3c-6.2-.2-9.03-.35-11.3-2.55-2.2-2.27-2.36-5.1-2.55-11.3h-.3c-.2 6.2-.35 9.03-2.55 11.3-2.27 2.2-5.1 2.36-11.3 2.55v.3c6.2.2 9.03.35 11.3 2.55 2.2 2.27 2.36 5.1 2.55 11.3h.3c.2-6.2.35-9.03 2.55-11.3 2.27-2.2 5.1-2.36 11.3-2.55"
													/>
												</svg>
											</a>
										</div>
									)}
								</div>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

export default withStyles(styles)(Footer);
